import { CommonModule } from '@angular/common';
import { Directive, HostListener, NgModule } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieConsentDialogComponent } from '@shared/cookie-consent';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appCookiePopupTrigger]',
    standalone: false
})
export class CookiePopupTriggerDirective {
  @HostListener('click') onclick() {
    this.openDialog();
  }

  openDialog() {
    this._dialog.open(CookieConsentDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      hasBackdrop: true,
      disableClose: false,
    });
  }

  constructor(private _dialog: MatDialog) {}
}

@NgModule({
  declarations: [CookiePopupTriggerDirective],
  imports: [CommonModule],
  exports: [CookiePopupTriggerDirective],
  providers: [],
})
export class CookiePopupTriggerModule {}
